import { OverflowTooltip } from '@/components';
import { TableColumn, TableRow } from '@/components/Table/types';
import { Trans } from 'react-i18next';

type KpiAutomationsNameColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
  onClick?: (row?: T) => void;
};

export const kpiAutomationsNameColumnConfig = <T extends TableRow>({
  options,
  onClick,
}: KpiAutomationsNameColumnConfig<T>): TableColumn<T> => ({
  id: 'automationName',
  label: <Trans i18nKey="automation_name" />,
  render: (value, row) => (
    <div onClick={() => onClick?.(row)}>
      <OverflowTooltip showArrow text={value} />
    </div>
  ),
  acessorKey: 'automationName',
  sortable: true,
  align: 'left',
  alignHeader: 'left',
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
